// extracted by mini-css-extract-plugin
var _1 = "_fxk4W";
var _2 = "_zINE7";
export { _1 as "fullPageLoader", _2 as "loadingComponent" }
